import { render, staticRenderFns } from "./3_contactLens.vue?vue&type=template&id=3f19e712&scoped=true&"
import script from "./3_contactLens.vue?vue&type=script&lang=js&"
export * from "./3_contactLens.vue?vue&type=script&lang=js&"
import style0 from "./3_contactLens.vue?vue&type=style&index=0&id=3f19e712&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3f19e712",
  null
  
)

export default component.exports